import React, { useCallback, useState } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { Button } from 'js/components/common/Button';
import { Icon } from 'js/components/common/Icon';
import { getClassNames } from 'js/utils/classNames.util';

import * as hooks from './hooks';

import style from './ReadMore.scss';

export const ReadMore = (props) => {
    const { children, className, buttonClassName, lines = 4 } = props;
    const t = useTranslations('playtech.mobile.system.details.');
    const [setNodeRef, height, compressedHeight] = hooks.useHeights({ lines });
    const [isExpanded, setIsExpanded] = useState(false);
    const onButtonClick = useCallback(() => setIsExpanded(value => !value), []);
    const isShowButton = parseFloat(height) > parseFloat(compressedHeight);

    return (
        <div>
            <div
                className={style.container}
                style={{ maxHeight: isExpanded ? height : compressedHeight }}
            >
                <div
                    ref={setNodeRef}
                    className={className}
                >
                    {children}
                </div>
            </div>
            {isShowButton && (
                <div className={getClassNames([!isExpanded && style.fadingLine])}>
                    <Button
                        view="secondary"
                        color="info"
                        size="medium"
                        onClick={onButtonClick}
                        className={getClassNames([
                            style.button,
                            style.info,
                            buttonClassName
                        ])}>
                        {t(isExpanded ? 'hide' : 'readMore')}
                        <Icon
                            type="showMoreArrow"
                            className={getClassNames([
                                style.icon,
                                isExpanded && style.expanded
                            ])}
                        />
                    </Button>
                </div>
            )}
        </div>
    );
};
